import axios from "../axiosClient";

export const getSLS = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Supplier/getall`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};

export const getAllSLS = async (
  signal: any,
  PageNumber: any = 0,
  pageSize: any = 0
) => {
  const res = await axios.get(`/slpapp/Supplier/getall`, {
    params: { PageNumber, pageSize },
    signal,
  });

  return res?.data;
};
